/**
 * Catálogo de fuerzas políticas y coaliciones.
 *
 * La lista de 9 partidos de §Bloque 5 es: MORENA, PVEM, PT, PAN, PRI, MC,
 * PES BC, PAZ y SOMOS. La coalición "Juntos Haremos Historia" se define de
 * forma idéntica en todo el documento como MORENA + PVEM + PT (corrección #2
 * de la versión 2).
 */
export const PARTY_IDS = [
    'MORENA',
    'PVEM',
    'PT',
    'PAN',
    'PRI',
    'MC',
    'PES_BC',
    'PAZ',
    'SOMOS',
];
export const PARTIES = [
    { id: 'MORENA', label: 'MORENA', colorHex: '#9F2241' },
    { id: 'PVEM', label: 'PVEM', colorHex: '#4CAF50' },
    { id: 'PT', label: 'PT', colorHex: '#D32F2F' },
    { id: 'PAN', label: 'PAN', colorHex: '#0D47A1' },
    { id: 'PRI', label: 'PRI', colorHex: '#00913F' },
    { id: 'MC', label: 'MC', colorHex: '#F57C00' },
    { id: 'PES_BC', label: 'PES BC', colorHex: '#6A1B9A' },
    { id: 'PAZ', label: 'PAZ', colorHex: '#00897B' },
    { id: 'SOMOS', label: 'SOMOS', colorHex: '#C2185B' },
];
export const PARTY_LABELS = Object.fromEntries(PARTIES.map((p) => [p.id, p.label]));
/* -------------------------------------------------------------------------- */
/*                                 Coaliciones                                */
/* -------------------------------------------------------------------------- */
export const COALITION_IDS = ['JHH', 'PAN_PES', 'PAN_PRI_PES'];
export const COALITIONS = [
    {
        id: 'JHH',
        label: 'Juntos Haremos Historia',
        spokenLabel: 'la coalición Juntos Haremos Historia: MORENA, PVEM y PT',
        components: ['MORENA', 'PVEM', 'PT'],
    },
    {
        id: 'PAN_PES',
        label: 'PAN + PES BC',
        spokenLabel: 'la alianza PAN – PES BC',
        components: ['PAN', 'PES_BC'],
    },
    {
        id: 'PAN_PRI_PES',
        label: 'PAN + PRI + PES BC',
        spokenLabel: 'la alianza PAN – PRI – PES BC',
        components: ['PAN', 'PRI', 'PES_BC'],
    },
];
export const COALITION_BY_ID = Object.fromEntries(COALITIONS.map((c) => [c.id, c]));
/* -------------------------------------------------------------------------- */
/*                      Resultado oficial 2024 (referencia)                   */
/* -------------------------------------------------------------------------- */
/**
 * Cómputo IEEBC, Ayuntamiento de Tecate 2024. Sirve para validar el recuerdo
 * de voto P6 contra el resultado real (§5 nota y §6 paso 4).
 *
 * Nota: en Tecate el PT compitió por separado, por lo que la "coalición
 * MORENA 2024" del marco es MORENA + PVEM + Fuerza por México BC.
 */
export const RESULT_2024_MUNICIPAL = {
    participationRate: 0.49,
    listaNominal: 96_918,
    votosCasillasOrdinarias: 47_447,
    /** Proporción sobre votos emitidos. */
    shares: {
        coalicionMorena: 0.557,
        PES_BC: 0.214,
        PAN: 0.07,
        PT: 0.056,
        PRI: 0.033,
        MC: 0.019,
        PRD: 0.007,
        nulos: 0.041,
    },
    /** Votos absolutos reportados en §4.1 para validación del marco. */
    votes: {
        coalicionMorenaPvemFxm: 26_449,
        PES_BC: 10_178,
        PAN: 3_314,
        PT: 2_648,
        PRI: 1_579,
        MC: 922,
    },
};
/** Lista nominal INE al 29 de enero de 2026, universo del estudio. */
export const LISTA_NOMINAL_2026 = 101_634;
//# sourceMappingURL=parties.js.map